exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".socials-wrapper{display:none}@media (min-width:768px){.socials-wrapper{display:none}.socials-wrapper>div{display:none}.socials-wrapper>div #instafeed{text-align:center}}", ""]);

// exports
